<template>
  <div class='card'>
    <div class='card-header'>
      <label class='az-content-label' style='text-transform: none'>Investment Summary</label>
    </div>

    <!-- keeps your existing ElementUI v-loading for initial data fetch -->
    <div class='card-body tx-13' v-loading='loading'>
      <div class="table-responsive">
        <table class="table mg-b-0">
          <thead>
            <tr>
              <th>Asset Class</th>
              <th>Value</th>
              <th>Percentage</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(value,key) in data.assets_sorted" :key='key'>
              <td>{{key}}</td>
              <td>{{currentformats.AUformat(value)}}</td>
              <td>{{(value/data.total_value*100).toFixed(2)+'%'}}</td>
            </tr>
            <tr>
              <td><strong>Total</strong></td>
              <td>{{currentformats.AUformat(data.total_value)}}</td>
              <td>100%</td>
            </tr>
          </tbody>
        </table>
      </div>

      <br><br>
      <div>
        <a
          href="#"
          @click.prevent="getReport(report6, 'InvestmentAllocation')"
          :class="{ 'is-loading': loadingReport === 'InvestmentAllocation' }"
        >
          <span class='tx-12'>
            Investment Summary Report
            <i :class="loadingReport === 'InvestmentAllocation' ? 'el-icon-loading' : 'el-icon-download'"></i>
          </span>
        </a>
      </div>

    </div>
  </div>
</template>

<script>
import currentformats from '../../../utils/currentformats'
import { downloadReport } from '@/utils/classReports';

export default {
  name:'fundnavinvestments',
  data(){
    return{
      currentformats,
      data:{
        assets_sorted:null,
        total_value:'',
      },
      bgl_report: {},
      marketValue_sum:0,
      loading:true,          // page data loader (ElementUI v-loading)
      loadingReport:null,    // per-action loader for the report link
      isbgl:false,
      fund_name:this.$route.query.name,
      report6: this.$route.params.fund_code + '+InvestmentAllocation',
    }
  },
  created(){
    this.getInvestmentsData();
    const userdetail = JSON.parse(localStorage.getItem('userdetail'));
    this.isbgl = userdetail['isBGL']
    if(this.isbgl){
      this.getBGLReport();
    }
  },
  methods:{
    async getReport(report, code) {
      if (this.loadingReport) return;     // prevent parallel clicks
      this.loadingReport = code;
      try {
        await downloadReport({
          report,
          api: this.$api.funddashboard_api,
          fallbackName: 'report.pdf',
        });
      } catch (err) {
        console.error('Failed to fetch or display report:', err);
      } finally {
        this.loadingReport = null;
      }
    },
    getInvestmentsData(){
      this.$api.funddashboard_api.fundInvestments(this.$route.params.fund_code).then(response =>{
        this.data.assets_sorted = response.data["assets_sorted"]
        this.data.total_value = response.data["total_value"]
        this.loading=false
      });
    },
    getBGLReport(){
      this.$api.funddashboard_api.bgl_report(this.$route.params.fund_code).then(response =>{
        this.bgl_report = response.data['report'];
        this.marketValue_sum = response.data['marketValue_sum']
      });
    },
  }
}
</script>

<style scoped>
.is-loading {
  pointer-events: none;
  opacity: .7;
}
</style>
